export const RECEIVE_SUBLIME_NARVAR_APP_CTA = 'RECEIVE_SUBLIME_NARVAR_APP_CTA';

export const receiveSublimeNarvarAppCta = (data) => {
  let parsedData = {};
  try {
    parsedData = JSON.parse(data) || {};
  } catch (e) {
    parsedData = {};
  }
  return {
    type: RECEIVE_SUBLIME_NARVAR_APP_CTA,
    data: parsedData,
  };
};
